module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAAXNSR0IArs4c6QAAAR5JREFUOE+t07ErhlEUx/HvD4WiDBK7XWaDhRELRv4C4zspmwzCZDKblQxIFoP/QBkwMZgoCeGnW88j73Wf+z7KXc85n3vPveeKf1jKGbZDvB94lPRWlZtEbLcBU0AD6CqKt4HdFFaFTAMriZ2PgWVJ/hn7hdjuBs4ybc5Ium2FDAIHGWRB0kUrpA84ySDzkq6zSAjaXgMmE9AdMBtfbtXFdgD7wEAETUh6iPHKOSlmpAcYAa6Ae0kfqTZTrzMKrAO9QHtU9AKcAquSXstYE2J7DNhMFMcHuAQWJb2HwDdiuxM4LE5Q50eFoTuKkdDGTp3qIudc0lKMjAMbf0BuJM3FyBCwBQzXgJ5DrqS9JqQstB1+bZjaqhWAJ0mfZcIXsLNZEgptLP0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chGuys.png
// module id = 7u5N
// module chunks = 0